import React, { Component } from "react";

import { Router, Route, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";

import UserRequests from "./user_requests/user_requests.router";
import Payments from "./payments/payments.router";
import Login from "./components/login.component";
import InvoicesRouter from "./invoices/invoices.router";
import EntityInvoicesRouter from "./entity_invoices/entity_invoices.router";
import Entities from "./entities/entities.router";
import EstablishmentsRouter from "./establishments/establishments.router";
import TestimonialsRouter from "./testimonials/testimonials.router";
import VisitsRouter from "./visits_list/visits.router";
import EmailValidator from "./email_validator/email_validator.router";
import CreditNotesRouter from "./credit_notes/credit_notes.router";
import RequestsHistoryRouter from "./requests_history/requests_history.router";
import DashboardRouter from "./dashboard/dashboard.router";
import StatisticsRouter from "./statistics/statistics.router";
import CallTypesRouter from "./call_types/call_types.router";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faEuroSign } from "@fortawesome/free-solid-svg-icons";
import {
  faShare,
  faComments,
  faCheck,
  faEye,
  faCheckCircle,
  faAt,
  faPhone,
  faMailBulk,
  faEnvelope,
  faFilter,
  faCircle,
  faHome,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import AppBar from "./components/app-bar";
import createBrowserHistory from "history/createBrowserHistory";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Api } from "./utils/api";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import CallsBookedRouter from "./calls_booked/callsbooked.router";
import EntityGroupsRouter from "./entity_groups/entity_groups.router";

import { QueryClient, QueryClientProvider } from "react-query";

const history = createBrowserHistory();
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0a334c" /*#0d47a1*/,
    },
  },
});

library.add(faEuroSign);
library.add(faShare);
library.add(faCheck);
library.add(faComments);
library.add(faEye);
library.add(faCheckCircle);
library.add(faAt);
library.add(faPhone);
library.add(faMailBulk);
library.add(faEnvelope);
library.add(faFilter);
library.add(faCircle);
library.add(faHome);
library.add(faClock);

const queryClient = new QueryClient();

class App extends Component {
  api = null;

  constructor() {
    super();
    this.api = new Api();
  }
  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <NotificationContainer />
        <Router history={history}>
          <MuiThemeProvider theme={theme}>
            <AppBar />
            {this.api.loggedIn() && (
              <>
                <Route path="/dashboard" component={DashboardRouter} />
                <Route path="/statistics" component={StatisticsRouter} />
                <Route path="/user_requests" component={UserRequests} />
                <Route path="/callsbooked_list" component={CallsBookedRouter} />
                <Route path="/visits_list" component={VisitsRouter} />
                <Route path="/call_types" component={CallTypesRouter} />
                <Route
                  path="/establishments"
                  component={EstablishmentsRouter}
                />
                <Route path="/testimonials" component={TestimonialsRouter} />
                <Route path="/entities" component={Entities} />
                <Route path="/entity_groups" component={EntityGroupsRouter} />
                <Route path="/payments" component={Payments} />
                <Route path="/invoices" component={InvoicesRouter} />
                <Route
                  path="/entity_invoices"
                  component={EntityInvoicesRouter}
                />
                <Route path="/credit_notes" component={CreditNotesRouter} />
                <Route
                  path="/requests_history"
                  component={RequestsHistoryRouter}
                />
                <Route path="/email_validator" component={EmailValidator} />
                <Route path="/login" component={Login} />
                <Route
                  path="/logout"
                  render={() => {
                    this.api.logout();
                    return <Redirect to="/login" />;
                  }}
                />
                <Route
                  exact
                  path="/"
                  render={() => <Redirect to="/user_requests" />}
                />
              </>
            )}
            {!this.api.loggedIn() && <Route component={Login} />}
          </MuiThemeProvider>
        </Router>
      </QueryClientProvider>
    );
  }
}

export default App;
